import React from "react";

function parseSurveyJson(surveyJson) {
    // SurveyJson comes in the form of json. First, you have a "pages" key, which is an array of pages. Each page has a "elements" key, which is an array of questions.
    // Each question has a "title" key, which is the question text. It also has a "type" key, which is the type of question (text, radio, etc).
    // Finally, screener questions may have one of a "correctAnswers" or "incorrectAnswers" key, which is an array of correct or incorrect answers, respectively.
    // Parse the json into an array of questions, each of which has a title, type, and correctAnswers or incorrectAnswers key, and a containsScreenerLogic key.

    if (surveyJson == null) return [];
    if (surveyJson.pages == null) return [];

    let questions = [];
    let pages = surveyJson.pages;
    for (let i = 0; i < pages.length; i++) {
        let page = pages[i];
        let elements = page.elements;
        if (elements == null) continue;
        for (let j = 0; j < elements.length; j++) {
            let element = elements[j];
            let question = {
                title: element.title,
                type: element.type,
                correctAnswers: element.correctAnswers,
                incorrectAnswers: element.incorrectAnswers,
                containsScreenerLogic: element.correctAnswers || element.incorrectAnswers
            }
            questions.push(question);
        }
    }
    return questions;
}

export { parseSurveyJson };
